import * as React from "react";

import { CountUp } from "@/shared/motion/CountUp";
import { cn } from "@/shared/lib/utils";

/**
 * 紧凑统计瓦片:居中大号数值 + label(+ 可选趋势)。
 * 区别于 StatCard(独立卡、左对齐,整页头条 KPI 用):StatTile 无 Card 包裹,
 * 用于「一个 Card 内多指标并列」(漏斗、留资转化等),收口此前手搓的重复 text-center 瓦片。
 */
export function StatTile({
  label,
  value,
  accent,
  trend,
}: {
  label: React.ReactNode;
  value: React.ReactNode;
  accent?: string;
  trend?: React.ReactNode;
}) {
  return (
    <div className="text-center">
      <div className={cn("text-2xl font-bold tabular-nums", accent)}>
        {typeof value === "number" && Number.isInteger(value) ? (
          <CountUp to={value} comma />
        ) : (
          value
        )}
      </div>
      <div className="flex items-center justify-center gap-1 text-xs text-muted-foreground">
        {label}
        {trend}
      </div>
    </div>
  );
}
